/* eslint-disable */
export default {
  save: (key, jsonData, expirationMin, type = 'fixed') => {
    if (typeof (Storage) === 'undefined') { return false; }
    const expirationMS = expirationMin * 60 * 1000;
    const currentTime = new Date().getTime();
    const record = {
      value: JSON.stringify(jsonData),
      ttl: currentTime + expirationMS,
      type,
      expirationMin,
    };
    localStorage.setItem(key, JSON.stringify(record));
    return jsonData;
  },
  load: (key) => {
    if (typeof (Storage) === 'undefined') { return false; }
    const record = JSON.parse(localStorage.getItem(key));
    const currentTime = new Date().getTime();
    if (!record) { return false; }
    if (currentTime > record.ttl) {
      localStorage.removeItem(key);
      return false;
    }
    if (currentTime < record.ttl && record.type === 'variable') {
      const recordCopy = JSON.parse(localStorage.getItem(key));
      localStorage.removeItem(key);
      const expirationMS = recordCopy.expirationMin * 60 * 1000;
      recordCopy.ttl = new Date().getTime() + expirationMS;
      localStorage.setItem(key, JSON.stringify(recordCopy));
      return recordCopy;
    }
    return (currentTime < record.ttl && JSON.parse(record.value));
  },
};



// WEBPACK FOOTER //
// ./src/utils/localstorage-common.js